import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { ModalBody } from '../../../components/modal/Modal';
import { ITableSet } from '../../../components/table/Table';
import TableWithPagination from '../../../components/table/tableWithPagination/TableWithPagination';
import { IState } from '../../../redux/store';
import { updateParam } from '../../../redux/progress/param/paramAction'
import { IModuleParams } from '../../../redux/progress/param/paramReducer';
import { useParams } from 'react-router';
import useTableDataWithPagination from '../../../components/table/tableWithPagination/useTableDataWithPagination';
import { urls } from '../../../config/url';
import DirPickerFliter, { IDirPickerFliterData } from './DirPickerFliter';
import { IModuleParam } from '../../../redux/progress/module/moduleInterface';
import { IDataDirInfo } from './DataDirInfo';
import { FormattedMessage } from 'react-intl';

function DirPicker(props: {
    userName: string,
    activeProjectName: string,
    close: () => void,
    updateParam: (param: IModuleParams) => void;
    param: IModuleParam;
    onChange?: (value: string) => void;
}) {


    const [fliter, setFliter] = useState<IDirPickerFliterData>({});

    const tableSets: ITableSet[] = [
        {
            titleId: "dir_name",
            key: "USERDATADIR_NAME"
        },
        {
            titleId: "user_name",
            key: "USER_NAME"
        },
        {
            titleId: "project_name_header",
            key: "PROJECTNAME"
        },
        {
            titleId: "speciality",
            key: "SPECIALITYCLASS",
            cover: (rowindex, rowData: IDataDirInfo) => {
                return <FormattedMessage id={rowData.SPECIALITYCLASS} />
            }
        },
        {
            titleId: "technology",
            key: "TECHNOLOGYCLASS",
            cover: (rowindex, rowData: IDataDirInfo)=>{
                return <FormattedMessage id={rowData.TECHNOLOGYCLASS? rowData.TECHNOLOGYCLASS:'empty'}/>
            }
        },
        {
            titleId: 'update_time',
            key: 'update_time',
            handleSort: (a, b) => { return a-b },
            cover: (rowindex, rowData) => {
                return <>{new Date(rowData.update_time).toLocaleString()}</> 
            }
        },
        // {
        //     titleId: "comment",
        //     key: ""
        // },
        {
            titleId: "empty",
            cover: (rowIndex: number, dirInfo: any) => {
                return (
                    <button
                        key={rowIndex}
                        className="btn btn-primary"
                        onClick={() => {
                            props.updateParam({ [props.param.PARAMNAME]: `${dirInfo.storepath}${dirInfo.relative_file_path}` }); // eslint-disable-line
                            props.onChange?.(`${dirInfo.storepath}${dirInfo.relative_file_path}`);
                            props.close();
                        }}
                    >
                        选择
                    </button>
                )

            }
        }
    ]

    const { spec } = useParams<{ spec: string }>()

    const param = useTableDataWithPagination(urls.listUserDirByPage, {
        USER_NAME: props.userName,
        PROJECTNAME: props.activeProjectName,
        SPECIALITYCLASS: spec,
        FIELD_USERDATACLASS: 1,
        ...fliter
    });

    useEffect(() => {
        param.update();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fliter]);

    return <ModalBody>
        <DirPickerFliter onChanged={(value) => setFliter(value)} />
        <TableWithPagination param={param} tableSets={tableSets} />
    </ModalBody>
}

const mapStateToProps = (state: IState) => {
    return {
        userName: state.user.userName,
        activeProjectName: state.project.activeName
    };
};


export default connect(
    mapStateToProps,
    { updateParam }
)(DirPicker);